export const GeneralStatus = [
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'inactive',
    description: 'Inactive',
  },
];

export const VoucherStatus = [
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'inactive',
    description: 'Inactive',
  },
  {
    value: 'expired',
    description: 'Expired',
  },
];

export const VoucherRemitterStatus = [
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'expired',
    description: 'Expired',
  },
  {
    value: 'voided',
    description: 'Voided',
  },
  {
    value: 'used',
    description: 'Used',
  },
];

export const AnnouncementStatus = [
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'inactive',
    description: 'Inactive',
  },
  {
    value: 'pending',
    description: 'Pending',
  },
];

export const BeneficiaryStatus = [
  {
    value: 'pending',
    description: 'Pending',
  },
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'inactive',
    description: 'Inactive',
  },
  {
    value: 'blacklisted',
    description: 'Blacklisted',
  },
];

export const RemitterStatus = [
  {
    value: 'active',
    description: 'Active',
  },
  {
    value: 'inactive',
    description: 'Inactive',
  },
  {
    value: 'pending_kyc',
    description: 'Pending KYC',
  },
  {
    value: 'onfido_kyc_ongoing',
    description: 'Onfido KYC Ongoing',
  },
  {
    value: 'pending_onfido_kyc_fin_to_pr_nric',
    description: 'Pending Onfido KYC FIN to PR NRIC',
  },
  {
    value: 'pending_pass_expiry_review',
    description: 'Pending Pass Expiry Review',
  },
  {
    value: 'remitter_pass_expiry_renewal_approved',
    description: 'Remitter Pass Expiry Renewal Approved',
  },
  {
    value: 'remitter_pass_expiry_renewal_rejected',
    description: 'Remitter Pass Expiry Renewal Rejected',
  },
  {
    value: 'pending_profile_updates_approval',
    description: 'Remitter Profile Update Approval',
  },
  {
    value: 'update_remitter_approved',
    description: 'Update Remitter Approved',
  },
  {
    value: 'update_remitter_rejected',
    description: 'Update Remitter Rejected',
  },
];

export const KycStatus = [
  {
    value: 'approved',
    description: 'Approved',
  },
  {
    value: 'rejected',
    description: 'Rejected',
  },
  {
    value: 'pending_kyc',
    description: 'Pending KYC',
  },
  {
    value: 'pending_manual_kyc',
    description: 'Pending Manual KYC',
  },
  {
    value: 'onfido_kyc_ongoing',
    description: 'Onfido KYC Ongoing',
  },
  {
    value: 'pending_onfido_kyc_fin_to_pr_nric',
    description: 'Pending Onfido KYC FIN to PR NRIC',
  },
  {
    value: 'onfido_approved',
    description: 'Onfido Approved',
  },
  {
    value: 'onfido_rejected',
    description: 'Onfido Rejected',
  },
];

export const AdditionaFileRequestStatus = [
  {
    value: 'pending_upload',
    description: 'Pending Upload',
  },
  {
    value: 'pending_review',
    description: 'Pending Review',
  },
  {
    value: 'pending_approval',
    description: 'Pending Approval',
  },
  {
    value: 'reviewed',
    description: 'Reviewed',
  },
  {
    value: 'approved',
    description: 'Approved',
  },
  {
    value: 'rejected',
    description: 'Rejected',
  },
];

export const TransactionStatus = [
  {
    value: 'pending_approval',
    description: 'Pending Approval',
  },
  {
    value: 'pending_payment',
    description: 'Pending Payment',
  },
  {
    value: 'cancelled',
    description: 'Cancelled',
  },
  {
    value: 'approved',
    description: 'Completed',
  },
  {
    value: 'rejected',
    description: 'Rejected',
  },
  {
    value: 'incompleted',
    description: 'Incompleted',
  }
] as const;
